import { render, staticRenderFns } from "./ledtemplete.vue?vue&type=template&id=894c9e82"
import script from "./ledtemplete.vue?vue&type=script&lang=js"
export * from "./ledtemplete.vue?vue&type=script&lang=js"
import style0 from "./ledtemplete.vue?vue&type=style&index=0&id=894c9e82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports